jQuery(function($) {
	L.NumberedDivIcon = L.Icon.extend({
		options: {
			number: '',
			shadowUrl: null,
			iconSize: new L.Point(22, 22),
			iconAnchor: new L.Point(11, 11),
			popupAnchor: new L.Point(0, -11),
			className: 'bg-primary rounded-full text-center font-medium tracking-tighter leading-none text-sm py-1 text-link border border-dark'
		},

		createIcon: function () {
			var div = document.createElement('div');
			div.innerHTML = this.options['number'] || '';
			this._setIconStyles(div, 'icon');
			return div;
		},
	});

	if($('#location-map').length) {
		var lat = $('#location-map').attr('data-lat');
		var lng = $('#location-map').attr('data-lng');
		var map = L.map('location-map', {
			center: [(lat ? lat : 0), (lng ? lng : 0)],
			zoom: 18,
			scrollWheelZoom: true,
		});
		var markergroup = L.featureGroup([]).addTo(map);

		L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
			minZoom: 2,
			maxZoom: 20,
			ext: 'png',
			noWrap: true,
		}).addTo(map);

		if(lat && lng) {
			refreshMap(map, markergroup, lat, lng);
		} else {
			refreshMap(map, markergroup);
		}

		$(window).on('mwb/plugin/post_forms/added_posts', function () {
			markergroup.clearLayers();
			refreshMap(map, markergroup);
		});

		$('.othelocationmap #locate').click(function() {
			//jQuery(map.getContainer()).parent().removeClass('popup');
			map.locate({setView: false});
		});

		map.on('locationfound', function(e) {
			$('.othelocationmap #search-input').val('Current location');
			$('.othelocationmap #location-lat').val(e.latitude);
			$('.othelocationmap #location-lng').val(e.longitude);
			$('.othelocationmap form.posts-form').submit();
		});

		map.on('locationerror', function(e) {
			alert(e.message);
			$('.othelocationmap #search-input').val('');
			$('.othelocationmap #location-lat').val('');
			$('.othelocationmap #location-lng').val('');
		});

		map.on('click', function(e) {
			jQuery(map.getContainer()).parent().removeClass('popup');
		});
	}
});

function refreshMap(map, markergroup, setlat = false, setlng = false) {
	jQuery(map.getContainer()).parent().removeClass('popup');
	var markers = jQuery('.location-marker');

	markers.each(function(i) {
		var lat = jQuery(this).attr('data-lat');
		var lng = jQuery(this).attr('data-lng');
		var marker = L.marker([ lat, lng ], { icon: new L.NumberedDivIcon({ number: i + 1 }) } );
		var html = jQuery(this).find('.location-popup').html();

		marker.on('click', function(e) {
			jQuery(map.getContainer()).parent().addClass('popup').find('#location-popup').html(html);
			map.setView(this.getLatLng(), 6);
		});

		markergroup.addLayer(marker);
	});

	if(!setlat || !setlng) map.fitBounds(markergroup.getBounds().pad(0.1));
}